import { createFileRoute, redirect } from "@tanstack/react-router";
import { getHomePath } from "~/lib/applicationId";
import { useAuthStore } from "~/stores/useAuthStore";

export const Route = createFileRoute("/")({
  beforeLoad: () => {
    const token = useAuthStore.getState().token;
    throw redirect({ to: token ? getHomePath() : "/login" });
  },
});
